import { render, staticRenderFns } from "./FooterBn.vue?vue&type=template&id=a3821300&scoped=true&"
import script from "./FooterBn.vue?vue&type=script&lang=js&"
export * from "./FooterBn.vue?vue&type=script&lang=js&"
import style0 from "./FooterBn.vue?vue&type=style&index=0&id=a3821300&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3821300",
  null
  
)

export default component.exports